import React, { Component } from 'react';
import { connect } from 'react-redux';

import StagingLoginFormComponent from './StagingLoginFormComponent';
import { StagingLoginModalComponentContainer } from './StagingLoginModalComponentStyle';

class StagingLoginModalComponent extends Component {
    render() {
        const { currentPath = '/', redirection } = this.props;
        return (
            <StagingLoginModalComponentContainer>
                <h1>Staging Authentication</h1>
                <StagingLoginFormComponent currentPath={redirection || currentPath} />
            </StagingLoginModalComponentContainer>
        );
    }
}

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        notRegisteredText: state.i18n.feature.form.NOT_REGISTERED,
        registerText: state.i18n.page.register.BUTTON_REGISTER
    };
};

export default connect(mapStateToProps)(StagingLoginModalComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/staging/StagingLoginModalComponent.js